import React, { useContext } from 'react';
import { Show } from '../../utility/Show';

import { StoreContext } from '../../store';

const subscriptionPlans = [
  {
    tier: 'free',
    name: 'Free',
    price: 0,
    per_month: false,
    features: [
      "10 searches per month",
      "Summary Dashboard",
      "Lifestyle essentials score",
      "Sidewalk character score",
      "5-10-20 min walking distance",
      "Detail maps",
      "Compare neighborhoods",
      "Multiple search",
      "Filters",
      "Ratings",
      "Health metrics",
      "CO2 saved emissions",
    ],
  },
  {
    tier: 'premium',
    name: 'Premium',
    price: 29.99,
    per_month: true,
    features: [
      "Everything in free",
      "Unlimited search",
      "Mobile version",
      "Technical support",
      "White label format",
      "10 cities",
      "Client neighborhood quiz",
    ],
  },
  {
    tier: 'enterprise',
    name: 'Enterprise',
    price: 59.99,
    per_month: true,
    features: [
      "Everything in premium",
      "Bespoke customization",
      "Neighborhood report",
      "Analytics report",
      "Neighborhood Preference Profile",
      "30+ cities",
      "Relevancy search",
      "Neighborhood Recommendations",
    ],
  },
];

const SubscriptionPlans = ({ userDetails }) => {
  const { state, dispatch, actions, navigate } = useContext(StoreContext);
  const { isMobile } = state;

  const gotoContactUs = () => {
    navigate('/contact-us');
    document.title = 'Contact Us - Walkspan';
  };

  return (
    <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'}`}>
      {subscriptionPlans.map((plan, index) => {
        const isCurrentPlan = userDetails?.subscription?.tier === plan.tier;
        return (
          <div
            key={index}
            className='bg-[#252525] rounded-lg p-4 m-2 w-full max-w-[300px] flex flex-col gap-2 text-white text-left'
          >
            <h2 className='text-[#dcdcdc]'>{plan.name}</h2>
            <span className='text-lg'>
              {`$${plan.price}`}
              <Show.When isTrue={plan.per_month}>
                <span className='text-sm !text-[#8b8b8b]'> /month</span>
              </Show.When>
            </span>
            <ul className='features-list mb-4'>
              {plan.features.map((feature, index) => (
                <li key={index} className='text-[12px]'>
                  • {feature}
                </li>
              ))}
            </ul>
            <Show>
              <Show.When isTrue={isCurrentPlan}>
                <button
                  className={`mt-auto bg-white text-black p-1 text-center ${
                    isCurrentPlan
                      ? 'bg-[#8b8b8b] font-bold text-[#6d6d6d] cursor-not-allowed'
                      : 'cursor-pointer'
                  }`}
                >
                  <span className='text-xs text-gray'>Current Plan</span>
                </button>
              </Show.When>
              <Show.Else>
                <div className='mt-auto text-center text-sm'>
                  <span
                    className='font-bold cursor-pointer'
                    onClick={() => gotoContactUs()}
                  >
                    Contact us
                  </span> for more information
                </div>
              </Show.Else>
            </Show>

          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionPlans;
